// True when rich text from the editor contains something to read, e.g. not just "<p><br></p>".
export const hasVisibleText = (html) =>
  String(html || "")
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, " ")
    .trim() !== "";
